/* Gospel Archive — hero video: picks desktop/mobile source, respects reduced motion,
   never fetches a video source until it's actually going to play. */
(function () {
  'use strict';

  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var toggle = hero.querySelector('[data-hero-toggle-play]');
    var toggleLabel = hero.querySelector('[data-hero-toggle-label]');
    var mql = window.matchMedia('(min-width: 900px)');
    var reducedMotion = document.documentElement.getAttribute('data-reduced-motion') === 'true';
    var playing = false;
    var activeVideo = null;

    function activeVariant() {
      return mql.matches ? 'desktop' : 'mobile';
    }

    function getVideo(variant) {
      return hero.querySelector('[data-hero-video="' + variant + '"]') ||
        hero.querySelector('[data-hero-video="desktop"]') ||
        hero.querySelector('[data-hero-video="mobile"]');
    }

    function getPoster(variant) {
      return hero.querySelector('[data-hero-poster="' + variant + '"]') ||
        hero.querySelector('[data-hero-poster="desktop"]');
    }

    function showPosterOnly() {
      hero.querySelectorAll('[data-hero-poster]').forEach(function (p) { p.style.display = 'none'; });
      var poster = getPoster(activeVariant());
      if (poster) poster.style.display = 'block';
      hero.querySelectorAll('[data-hero-video]').forEach(function (v) { v.style.display = 'none'; });
    }

    function play() {
      var video = getVideo(activeVariant());
      if (!video) return;

      // iOS refuses programmatic playback unless muted is true as a *property*
      // and the clip is inline. The attributes alone are not always honoured
      // when the source is assigned after load.
      video.muted = true;
      video.playsInline = true;

      if (!video.getAttribute('src') && video.dataset.src) {
        video.setAttribute('src', video.dataset.src);
        video.load();
      }
      hero.querySelectorAll('[data-hero-poster]').forEach(function (p) { p.style.display = 'none'; });
      hero.querySelectorAll('[data-hero-video]').forEach(function (v) { v.style.display = 'none'; });
      video.style.display = 'block';
      activeVideo = video;

      // Only claim to be playing once the browser agrees. Autoplay is refused
      // outright in iOS Low Power Mode and by Safari's per-site auto-play
      // setting; in that case fall back to the poster so the control still
      // reads "play" and a tap actually starts it.
      var started = video.play();
      if (started && typeof started.then === 'function') {
        started.then(function () {
          playing = true;
          setToggleState(true);
        }).catch(function () {
          playing = false;
          showPosterOnly();
          setToggleState(false);
        });
      } else {
        playing = true;
        setToggleState(true);
      }
    }

    function pause() {
      if (activeVideo) activeVideo.pause();
      playing = false;
      showPosterOnly();
      setToggleState(false);
    }

    function setToggleState(isPlaying) {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
      var playIcon = toggle.querySelector('[data-hero-icon-play]');
      var pauseIcon = toggle.querySelector('[data-hero-icon-pause]');
      if (playIcon) playIcon.hidden = isPlaying;
      if (pauseIcon) pauseIcon.hidden = !isPlaying;
      if (toggleLabel) toggleLabel.textContent = isPlaying ? toggle.dataset.pauseLabel : toggle.dataset.playLabel;
    }

    // Initial state: never autoplay when reduced motion is requested.
    showPosterOnly();
    if (!reducedMotion) {
      play();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        if (playing) pause();
        else play();
      });
    }

    mql.addEventListener('change', function () {
      if (playing) play();
      else showPosterOnly();
    });
  });
})();
